import React, { useEffect, useState, useCallback } from "react";
import { getIsAuthenticated, getSecondaryToken, signIn } from "../../services/auth";
import PropTypes from "prop-types";
import scrollToTop from "../../utils/scroll-to-top-util";
import { govHubSubPath } from "../../utils/utils.js";
import { useGAContext } from "../../_contexts/ga-context/ga-context.js";
import { loadGSGScript } from "../../services/load-gsg-scripts.js";
import AlertService from "../alert-service/alert-service.js";
import GsgWidgetFooter from "../footer/gsg-widget-footer.js";


GSGWidget.propTypes = {
    initialPath: PropTypes.string,
    locationKey: PropTypes.string
};

const rootIframeUrl = process.env.REACT_APP_ROOTIFRAMEURL;

function GSGWidget({ initialPath, locationKey, ...props }) {
    const [language, setLanguage] = useState("");
    const [GATag, setGATag] = useState("");
    const consentGiven = useGAContext();

    useEffect(() => {
        const detectLanguageChange = () => {
            const detectedLang = document.documentElement.lang || "en";
            if (detectedLang !== "es") {
                setLanguage("en");
            } else {
                setLanguage(detectedLang);
            }
        };

        detectLanguageChange();

        const observer = new MutationObserver(() => detectLanguageChange());
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });

        return () => observer.disconnect();
    }, []);

    const initializeGSG = useCallback(async () => {
        try {
            await loadGSGScript(process.env.REACT_APP_GSG_WIDGET_SCRIPT, "GsgPublicSite");
            attachGSGPublicSite();
        } catch (error) {
            console.error("Error initializing GSGWidget:", error);
        }
    }, [language, GATag, initialPath, locationKey]);

    const attachGSGPublicSite = useCallback(() => {
        window.GsgPublicSite.attach({
            site: "ca-sanbernardino/ca-sanbernardino",
            rootIframeUrl,
            initialPath: initialPath,
            language,
            googleAnalytics: {
                googleTagId: GATag,
                userId: ""
            },
            elementSelector: "#gsg-embedded-public-site",
            onPathChange: newPath => {
                window.history.replaceState(null, "", `/${govHubSubPath}${newPath}`);

                scrollToTop();
            },
            getJwt: async () => {
                const isAuthenticated = await getIsAuthenticated();
                if (isAuthenticated) {
                    return getSecondaryToken();
                }
            },
            handleLogin: signIn
        });

    }, [GATag, language, initialPath]);

    useEffect(() => {
        initializeGSG();
    }, [initializeGSG]);

    useEffect(() => {
        setGATag(consentGiven.consentGiven ? process.env.REACT_APP_GOOGLE_ANALYTICS_ID : "");
    }, [consentGiven]);

    return (
        <>

            <div className="container">
                <AlertService showGSG={true} showGlobal={false} />
            </div>
            <div className="gsg-container">
                <div className="container mt-5">
                    <div className="row">
                        <div id="gsg-embedded-public-site"></div>
                        <GsgWidgetFooter />
                    </div>
                </div>
            </div>
        </>
    );
}

export default GSGWidget;
